import { TaxType } from "@/types/business/item.type";
import { TaxInterface } from "@/interface/business/item.interface";
import { FORM_TYPE } from "@/enums/apps.enum";

/**
 * Taxes Class
 *
 *
 applied: 133
 id: "4f724b4b-e73c-41d9-84af-bc38aaa23be2"
 is_custom_amount: false
 name: "industry inc"
 rate: 0.1
 type: "INCLUSIVE"
 */
export default class Tax implements TaxInterface {
  id: string;
  name: string;
  rate: number;
  type: string = "";
  inclusion_type: string;
  is_custom_amount: boolean;
  applied: number = 0;
  external_id?: string = "";
  formType: string = FORM_TYPE.CREATE;

  constructor(data: TaxType) {
    this.id = data.id;
    this.name = data.name;
    this.applied = data.applied || 0;
    this.type = data.type || "";
    this.rate = data.rate || 0;
    this.inclusion_type = data.inclusion_type;
    this.is_custom_amount = data.is_custom_amount || false;
    this.external_id = data.external_id || "";
  }

  setFormCreate(): void {
    this.formType = FORM_TYPE.CREATE;
  }

  setFormEdit(): void {
    this.formType = FORM_TYPE.EDIT;
  }

  setFormPreview(): void {
    this.formType = FORM_TYPE.PREVIEW;
  }

  isFormCreate(): boolean {
    return this.formType === FORM_TYPE.CREATE;
  }

  isFormEdit(): boolean {
    return this.formType === FORM_TYPE.EDIT;
  }

  isFormPreview(): boolean {
    return this.formType === FORM_TYPE.PREVIEW;
  }
}
